import { MenuItem } from "@mui/material";

import { IRules, IRulesReadjustment, ReadjustmentType } from "../../Setup.types";
import { Container, DatePicker, Row, SelectForm, TextField } from "./Rules.styled";

import { maskPercentage, parseDate } from "./Rules.utils";

interface IProps {
  rules: IRules;
  handleChange: (payload: Partial<IRules>) => void;
}

export function RulesTabReadjustment({ rules, handleChange }: IProps) {
  /** Função responsável especificamente por receber os valores alterados e formatar corretamente para handleChange. */
  function handleChangeReadjustment(payload: Partial<IRulesReadjustment>) {
    const updatedReadjustmentFields = { ...rules.rulesReadjustment, ...payload };

    handleChange({ ...rules, rulesReadjustment: updatedReadjustmentFields });
  }

  return (
    <Container>
      <Row>
        <DatePicker
          label="Início análise reajuste"
          format="DD / MMMM / YYYY"
          value={parseDate(rules.rulesReadjustment.analysisStartDate)}
          onChange={(e) => handleChangeReadjustment({ analysisStartDate: e?.toDate() })}
        />
        <DatePicker
          label="Fim análise reajuste"
          format="DD / MMMM / YYYY"
          value={parseDate(rules.rulesReadjustment.analysisEndDate)}
          onChange={(e) => handleChangeReadjustment({ analysisEndDate: e?.toDate() })}
        />
        <DatePicker
          label="Data programada do reajuste"
          format="DD / MMMM / YYYY"
          value={parseDate(rules.rulesReadjustment.scheduledDate)}
          onChange={(e) => handleChangeReadjustment({ scheduledDate: e?.toDate() })}
        />
        <DatePicker
          label="Mês do reajuste"
          format="MMMM / YYYY"
          value={parseDate(rules.rulesReadjustment.month)}
          onChange={(e) => handleChangeReadjustment({ month: e?.toDate() })}
        />
      </Row>
      <Row>
        <DatePicker
          label="Período de aplicação do reajuste"
          format="DD / MM / YYYY"
          value={parseDate(rules.rulesReadjustment.applicationPeriodDate)}
          onChange={(e) => handleChangeReadjustment({ applicationPeriodDate: e?.toDate() })}
        />
        <TextField
          label="Prêmio antes do reajuste"
          disabled
          value={rules.rulesReadjustment.previousPaymentAmount}
          onChange={(e) => handleChangeReadjustment({ previousPaymentAmount: Number(e.target.value) ?? 0 })}
        />
        <TextField
          label="Reajuste"
          value={maskPercentage(rules.rulesReadjustment.percentage)}
          onChange={(e) => handleChangeReadjustment({ percentage: e.target.value })}
        />
        <SelectForm
          label="Tipo de reajuste"
          value={rules.rulesReadjustment.type}
          onChange={(e) => handleChangeReadjustment({ type: e.target.value as ReadjustmentType })}
        >
          <MenuItem value={"SINISTRALIDADE_MOEDA"}>Sinistralidade + Moeda</MenuItem>
          <MenuItem value={"SINISTRALIDADE"}>Sinistralidade</MenuItem>
          <MenuItem value={"MOEDA"}>Moeda</MenuItem>
        </SelectForm>
      </Row>
    </Container>
  );
}
